(function($, undefined) {
	
	'use strict';
	var formValidator;
	var submitForgotPwBtn;
	
	var submitForgotPwForm = function() {
		var btn = $(this);
		var form = btn.closest('form');

		formValidator.validateForm(form, true);
		if (!form.hasClass('has-error')) {
			var url = '/action/forgotPassword';
			
			url += '?email=' + encodeURIComponent(form.find('input[name=email]').val());
			url += '&ajax=true';

			btn.addClass('disabled');
			
			var obj = ajax(url,function (response) {
				console.log(response);
				btn.removeClass('disabled');
				if (response.indexOf('not-validated') !== -1) {
					formValidator.showErrorPopup('not-validated');
					$('.show-resend-validation-btn').slideDown();
				} else {
					form.find('input').val('').removeClass('has-value');
					formValidator.showSuccessPopup('forgot-pw-success');
				}
			},true);
		}
	};

	var resendValidation = function() {
		var btn = $(this);
		var form = btn.closest('form');

		formValidator.validateForm(form, true);
		
		if (!form.hasClass('has-error')) {
			var url = '/action/createAccount';
			
			url += '?resendValidate=' + encodeURIComponent(form.find('input[name=email]').val());
			url += '&ajax=true';

			btn.addClass('disabled');
			
			ajax(url,function (response) {
				console.log(response);
				btn.removeClass('disabled');
				form.find('input').val('').removeClass('has-value');
				
				if (response.indexOf('no-account') !== -1) {
					formValidator.showErrorPopup('no-account');
				} else if (response.indexOf('account-validated') !== -1) {
					formValidator.showSuccessPopup('account-already-validated');
				} else if (response.indexOf('success') !== -1) {
					formValidator.showSuccessPopup('account-validation-sent');
				}
			},true);
		}
	};

	var toggleForgotPw = function() {
		var forgotPwCtn = $('.forgot-pw-ctn');
		var t = $(this);

		if (t.hasClass('no-title')) {
			forgotPwCtn.addClass('no-title');
		}

		forgotPwCtn.fadeToggle(function() {
			if (!t.hasClass('no-title')) {
				forgotPwCtn.removeClass('no-title');
			}
		});
	};

	var toggleResendValidation = function() {
		$('.resend-validation-ctn').fadeToggle();
	};
	
	var init = function () {
		formValidator = Fw.component.models().form;
		submitForgotPwBtn = $('.submit-forgot-pw-btn');
		
		$('.forgot-password-btn').click(toggleForgotPw);
		$('.show-resend-validation-btn').click(toggleResendValidation);
		$('.submit-resend-validation-btn').click(resendValidation);
		submitForgotPwBtn.click(submitForgotPwForm);
	};
	
	$(window).ready(function () {
		init();
	});
	
})(jQuery);